
import { Bot, Send, Loader2, Construction } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

interface AIChatDialogProps {
  profileId: string;
  onBack: () => void;
}

export const AIChatDialog = ({ profileId, onBack }: AIChatDialogProps) => {
  return (
    <div className="flex flex-col h-[60vh]">
      <div className="flex items-center gap-2 p-4 border-b border-blue-100/20">
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="text-blue-600 hover:text-blue-700"
        >
          ←
        </Button>
        <Bot className="w-5 h-5 text-blue-600" />
        <span className="font-medium text-gray-900">AI Assistant</span>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center space-y-4 max-w-md mx-auto">
          <div className="flex justify-center">
            <Construction className="w-12 h-12 text-blue-600 animate-bounce" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900">
            AI Assistant Coming Soon!
          </h3>
          <p className="text-gray-600">
            We're currently developing an enhanced AI assistant experience. 
            Check back soon for intelligent, personalized conversations!
          </p>
          <Button
            variant="outline"
            onClick={onBack}
            className="mt-4"
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};
